import client from '@/api/client';

export async function index({ search }) {
    return await client.get(`/districts?filter[name]=${search}`);
}